module.exports = __webpack_public_path__ + "img/dao4.d625deba.svg";